import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'gus-arrow-down-icon',
  standalone: true,
  templateUrl: './arrow-down-icon.component.html',
  styleUrl: './arrow-down-icon.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ArrowDownIconComponent {}
